export default {
    dashboard: {
        totalWordsGenerated: 'Total words generated',
        wordsPerDay: 'Words/day',
        content: 'Content',
        date: 'Date',
        variationCount: 'Variation Count',
        transactionId: 'Transaction ID',
        totalWordsCount: 'Total Words Count',
        action: 'Action',
        goTo: 'Go to',
        viewMore: 'View more',
        showLess: 'Show less',
        tabImage: 'Image',
        tabText: 'Text',
        dashboardSubtitle: 'Manage your AI generated content',
    },
};
